// ============================================================
// types/asistenciaDiaria.types.ts
// Asistencia diaria (entrada al colegio — modo portería).
// Distinta de la asistencia por curso (asistencia.types.ts).
// ============================================================

export type EstadoAsistenciaDiaria = 'PRESENTE' | 'TARDANZA' | 'AUSENTE' | 'JUSTIFICADO';

// ── Etiquetas y colores por estado ────────────────────────────

export const ESTADO_DIARIA_LABEL: Record<EstadoAsistenciaDiaria, string> = {
  PRESENTE:    'Presente',
  TARDANZA:    'Tardanza',
  AUSENTE:     'Ausente',
  JUSTIFICADO: 'Justificado',
};

export const ESTADO_DIARIA_COLOR: Record<EstadoAsistenciaDiaria, string> = {
  PRESENTE:    'bg-green-100 text-green-700 border-green-200',
  TARDANZA:    'bg-amber-100 text-amber-700 border-amber-200',
  AUSENTE:     'bg-red-100 text-red-700 border-red-200',
  JUSTIFICADO: 'bg-blue-100 text-blue-700 border-blue-200',
};

export const ESTADO_DIARIA_DOT: Record<EstadoAsistenciaDiaria, string> = {
  PRESENTE:    'bg-green-500',
  TARDANZA:    'bg-amber-500',
  AUSENTE:     'bg-red-500',
  JUSTIFICADO: 'bg-blue-500',
};

export const ESTADO_DIARIA_BG: Record<EstadoAsistenciaDiaria, string> = {
  PRESENTE:    'bg-green-500',
  TARDANZA:    'bg-amber-500',
  AUSENTE:     'bg-red-500',
  JUSTIFICADO: 'bg-blue-500',
};

export const ESTADOS_DIARIA: EstadoAsistenciaDiaria[] = ['PRESENTE', 'TARDANZA', 'AUSENTE', 'JUSTIFICADO'];

// ── Response del backend ──────────────────────────────────────

export interface AsistenciaDiariaResponse {
  idAsistenciaDiaria:   number;
  matriculaId:          number;
  estudianteId:         number;
  estudianteNombres:    string;
  estudianteApellidos:  string;
  estudianteDni:        string;
  nivel:                string;
  gradoNombre:          string;
  seccionNombre:        string;
  fecha:                string;       // YYYY-MM-DD
  estado:               EstadoAsistenciaDiaria;
  horaIngreso:          string | null; // HH:mm:ss
  motivo:               string | null;
  registradoPorId:      number | null;
  registradoPorNombres: string | null;
  fechaRegistro:        string;        // ISO datetime
  fechaActualizacion:   string | null;
}

// ── Payloads ──────────────────────────────────────────────────

export interface MarcarAsistenciaDiariaPayload {
  dni:           string;       // 8 dígitos
  horaIngreso?:  string;       // HH:mm:ss — si se omite, backend usa hora actual de Lima
}

export interface JustificarAsistenciaDiariaPayload {
  motivo: string;              // requerido, máx 255
}

export interface ActualizarAsistenciaDiariaPayload {
  estado:        EstadoAsistenciaDiaria;
  horaIngreso?:  string;       // HH:mm:ss
  motivo?:       string | null;
}
